import { useMutation } from '@tanstack/react-query';
import { getUserCredit } from '../../services';

export function useGetUserCredit() {
  return useMutation(getUserCredit, { onSuccess: (data) => data });
}
